import { Box, styled, Typography } from '@mui/material'
import { useController } from 'react-hook-form'
import { GeometryColorPicker } from './GeometryColorPicker'

interface IFormGeometryColorFieldProps {
  name: string
  label: string
  defaultValue?: string
  disabled?: boolean
}

export const FormGeometryColorField: React.FC<IFormGeometryColorFieldProps> = ({
  name,
  label,
  defaultValue,
  disabled,
}) => {
  const { field } = useController({ name, defaultValue })

  return (
    <StyledField>
      <Typography variant="body1">{label}</Typography>
      <GeometryColorPicker
        value={field.value ?? defaultValue}
        label={label}
        onChange={field.onChange}
        disabled={disabled}
      />
    </StyledField>
  )
}

const StyledField = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1),
}))
